let popupApi = null;
let nativeAlert = null;

export function bindAppPopup(api) {
  popupApi = api || null;
}

export function setNativeAlert(fn) {
  nativeAlert = typeof fn === "function" ? fn : null;
}

export function appAlert(message, options = {}) {
  const text = String(message || "");
  if (popupApi?.alert) return popupApi.alert(text, options);
  if (nativeAlert) nativeAlert(text);
  return Promise.resolve();
}

export function appConfirm(message, options = {}) {
  const text = String(message || "Are you sure?");
  if (popupApi?.confirm) return popupApi.confirm(text, options);
  return Promise.resolve(window.confirm(text));
}

export function appPrompt(message, options = {}) {
  const text = String(message || "");
  if (popupApi?.prompt) return popupApi.prompt(text, options);
  return Promise.resolve(window.prompt(text, options?.defaultValue || ""));
}
